/**
* Created By: Melissa López
* Creation Date: 14/09/2023
* PBI: 78286 - Vista Paso 1 Cotizador de Crédito
*
* Last Modifier:
* Last Modification: 
*
* Feat: 
*
* version: 1.0.0
* copyright: 2023 INDUSTRIAS RESSER S.A DE C.V
*/
import React, { useState, useEffect } from 'react';
import { useAppSelector } from '../hooks/storeHooks';
import { Row } from 'antd';
import { Grid } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useAppDispatch } from '../hooks/storeHooks';
import { getAnalytics, logEvent } from '@firebase/analytics';
import styles from '../styles/Step.style';
import CreditForm from '../components/CreditForm/CreditForm';
import ComponentPrice from '../components/Price/ComponentPrice';
import { formatNumber } from "../functions/formatPrice";
import { CircularProgress } from "@mui/material";
import { setCreditResultadoCotizacion } from '../reducer/slices/DataResponse';
import { getProductType, getCredit, getPlazo, getTasa } from '../reducer/slices/DataCotizador';
const useStyle = styles;

export const FirstStepCredit = () => {
    const classes = useStyle();
    const { width } = useAppSelector(state => state.dimensions);
    const Spacing = width < 700 ? 1 : 4;
    const dispatch: any = useAppDispatch();
    const dataCotizador = useAppSelector(state => state.DataCotizador);
    const { CreditResultCotizacion} = useAppSelector(state => state.DataResponse);
    const analytics = getAnalytics();

    useEffect(() => {
        logEvent(analytics, "view_first_screen");
    }, [])

        return (
            <>
                <>
                {
                        width < 700 && (
                            <CreditForm/>
                        )}
                </>
                <div className={classes.firstStepContainer} style={{textAlign:'center'}}>
                    <p className={classes.selectActiveTxt}>Resumen</p>
                    <Grid container spacing={Spacing} style={{ marginTop: 5, marginBottom: 20 }}>
                        <Grid item xs={12} md={4}>
                            <h3 className= {classes.resumeFieldsTxt}>Tipo de financiemiento</h3>
                            <p className={classes.resumeValueTxt}>{dataCotizador.productTypeOption == 0? "Crédito simple" : "Crédito Revolvente"}</p>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <h3 className= {classes.resumeFieldsTxt}>Monto de financiamiento</h3>
                            <p className={classes.resumeValueTxt}>{`$${formatNumber(dataCotizador.credit)}`}</p>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <h3 className= {classes.resumeFieldsTxt}>Plazos </h3>
                            <p className={classes.resumeValueTxt}>{dataCotizador.plazo}</p>
                        </Grid>
                        <Grid item xs={12} md={2}>
                        <h3 className= {classes.resumeFieldsTxt}>Comisión </h3>
                        <p className={classes.resumeValueTxt}>3% + IVA</p>
                    </Grid>
                    </Grid>
                <Grid item xs={12} sm={12} >
                    <h3 className= {classes.resumeFieldsTxt}>Simulación de amortización</h3>
                    <p className= {classes.warningFieldsTxt}>El presente ejercicio es una simulación de carácter
                        informativo y no representa una oferta o aprobación de crédito o financiamiento por parte 
                        de Financiera Bepensa, S.A. de C.V. Sofom, E.R. o cualquiera de sus afiliadas o asociadas.
                    </p>
                    {dataCotizador.tasa != 0&&(
                        <p className= {classes.warningFieldsTxt}>Tasa de interés variable basado en la TIIE vigente
                        más un margen de 7 a 16 puntos porcentuales. Como ejemplo representativo se utilizó una tasa
                        anual de {dataCotizador.tasa}%. Costo Anual Total (CAT) promedio: 15.74% sin IVA (quince punto setenta y cuatro por ciento).
                        </p>
                    )}
                </Grid>

                    <TableContainer style={{maxHeight: "350px"}}>
                        {dataCotizador.isLoadingData&&(
                            <div
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(255, 255, 255, 0.15)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 5,
                            }}
                        >
                            <CircularProgress size={40} /> {/* Spinner */}
                        </div>
                        )}
                        
                        <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                            <TableCell style={{ whiteSpace: "nowrap" }}>Periodo</TableCell>
                            <TableCell style={{ whiteSpace: "nowrap" }}>Saldo inicial</TableCell>
                            <TableCell style={{ whiteSpace: "nowrap" }}>Capital</TableCell>
                            <TableCell style={{ whiteSpace: "nowrap" }}>Interés</TableCell>
                            <TableCell style={{ whiteSpace: "nowrap" }}>Pago</TableCell>
                            <TableCell style={{ whiteSpace: "nowrap" }}>Saldo final</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {CreditResultCotizacion?.length > 0 && Array.isArray(CreditResultCotizacion[0].terms) && CreditResultCotizacion[0].terms.map(term => (
                            <TableRow key={term.term}>
                                <TableCell>{term.term}</TableCell>
                                <TableCell>{`$${formatNumber(term.initial_balance.toFixed(2))}`}</TableCell>
                                <TableCell>{`$${formatNumber(term.capital.toFixed(2))}`}</TableCell>
                                <TableCell>{`$${formatNumber((term.payment - term.capital).toFixed(2))}`}</TableCell> {/* Calcula el interés restando el capital del pago */}
                                <TableCell>{`$${formatNumber(term.payment.toFixed(2))}`}</TableCell>
                                <TableCell>{`$${formatNumber(term.final_balance.toFixed(2))}`}</TableCell>
                            </TableRow>
                            ))}
                        </TableBody>
                        </Table>
                    </TableContainer>
                <p className={classes.resumeValueTxt}>Podrá descargar su simulación al finalizar el proceso.</p>
                </div> 
            </>
        )
 
    }
